module.exports = __webpack_public_path__ + "assets/examine.a7931060.svg";